//setter methods which are used by several components are declared here
export const settersMixin = {
  methods: {
    /*Setters used in Roles*/

    //sets a select form with only student members of a project
    setStudentsOptions(data) {
      this.students = []

      data.map((item) => {
        const newOption = {
          attribution_date: item.attribution_date,
          user_role: item.user_role,
          value: item.user.id,
          text: `${item.user.first_name} ${item.user.last_name}`
        }

        this.students.push(newOption)
      })
    },

    //selects a student option in a select form who has the specified role id
    setSelectedOptionByStudentRoleId(input, roleId) {
      if (input.options.length > 0) {
        for (let i = 0; i < input.options.length; i++) {
          if (input.options[i].user_role === roleId) {
            input.selectedOption = {
              value: input.options[i].value,
              text: this.findOptionTextByValue(input.options, input.options[i].value)
            }
          }
        }
      }
    }
  }
}
